export const more_vertical = () => (
  <path
    d="M12 13a1 1 0 100-2 1 1 0 000 2zM12 6a1 1 0 100-2 1 1 0 000 2zM12 20a1 1 0 100-2 1 1 0 000 2z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
